import { EarnAssetDetailsAsset } from '../types'

export interface UseEarnAssetDetailsDataHandlers {
  onDeposit: (asset: EarnAssetDetailsAsset) => void
  onWithdraw: (asset: EarnAssetDetailsAsset) => void
}

export const EARN_ASSET_DETAILS_STATE = {
  LOADING: 'LOADING',
  NOT_FOUND: 'NOT_FOUND',
  READY: 'READY',
} as const

export type EarnAssetDetailsState =
  (typeof EARN_ASSET_DETAILS_STATE)[keyof typeof EARN_ASSET_DETAILS_STATE]

export interface EarnAssetDetailsDataCommon {
  isStatisticsLoading: boolean
  isDirectEarning: boolean
  portfolioId: string | undefined
}

export interface EarnAssetDetailsDataLoading {
  assetDetailsState: typeof EARN_ASSET_DETAILS_STATE.LOADING
}

export interface EarnAssetDetailsDataNotFound {
  assetDetailsState: typeof EARN_ASSET_DETAILS_STATE.NOT_FOUND
}

export interface EarnAssetDetailsDataReady {
  assetDetailsState: typeof EARN_ASSET_DETAILS_STATE.READY
  asset: string
  walletId: string
  epcTakesEarn: boolean
  earnRate: string
  customerEarnRate: string
  summary: {
    allocatedFunds: string
    unallocatedFunds: string
  }
  totalEarnings: {
    allocationEarnings: string
    customerEarnings: string
    totalEarnings: string
  }
  customerSummary: {
    customerEarningBalance: string
    customerUnpaidAmount: string
    customerPaidAmount: string
  }
  onDeposit: () => void
  onWithdraw: () => void
}

export type EarnAssetDetailsData = EarnAssetDetailsDataCommon &
  (EarnAssetDetailsDataLoading | EarnAssetDetailsDataNotFound | EarnAssetDetailsDataReady)
